import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Currency from 'react-currency-formatter';
import PopUp from '../popup/PopUp';
import BuyAccessoriesPopup from '../popup/BuyAccessoriesPopup';
import ShowBasketPopup from '../popup/ShowBasketPopup';

const AccessoriesRow = ({ item, index }) => {
  const [value, setValue] = useState(1);
  const width = item.real_dims.width ? `szer: ${item.real_dims['width']}/ ` : '';
  const length = item.real_dims.length ? `dł: ${item.real_dims['length']}/ ` : '';
  const height = item.real_dims.height ? `wys: ${item.real_dims['height']}/ ` : '';
  const depth = item.real_dims.depth ? `gł: ${item.real_dims['depth']}` : '';
  const diameter = item.real_dims.diameter ? `śr: ${item.real_dims['diameter']}` : '';

  const openPopup = name => {
    const popup = document.querySelector(`[data-popup-name="buy-accessories-popup-${name}"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  const properties = `${width}${length}${height}${depth}${diameter}`;
  const stringProperties = properties.length > 0 ? `${properties} cm` : '';

  return (
    <li className="buy-accessories__list-item" title={item.safo}>
      <img className="buy-accessories__list-img" src={item.icon} alt={item.name} />
      <p className="buy-accessories__list-name">{item.name}</p>
      <p className="buy-accessories__list-text">
        <span className="buy-accessories__list-pricing buy-accessories__list-pricing--price">
          <Currency quantity={item.price.actual} currency="PLN" />
        </span>
        {item.price.actual < item.price.regular && (
          <span className="buy-accessories__list-pricing buy-accessories__list-pricing--del">
            <del>
              <Currency quantity={item.price.regular} currency="PLN" />
            </del>
          </span>
        )}
      </p>
      <p className="buy-accessories__list-properties">{stringProperties}</p>
      <button className="buy-accessories__list-button" onClick={() => openPopup(item.safo)}>
        DODAJ DO KOSZYKA
      </button>
      <PopUp title=" " popupName={`buy-accessories-popup-${item.safo}`} noButton>
        <BuyAccessoriesPopup item={item} index={index} value={value} setValue={setValue} />
      </PopUp>
      <PopUp title=" " popupName={`show-basket`} noButton>
        <ShowBasketPopup />
      </PopUp>
    </li>
  );
};

AccessoriesRow.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number,
};

export default AccessoriesRow;
